// Search the website's pages.
const searchForm = document.querySelector(".search-form");
const results = document.querySelector(".search-results");

const pages = [
    {
        title: "Home — Rai Automotive",
        url: "/",
        words: "home rai automotive bmw mini rolls royce savings luxury european"
    },
    {
        title: "Services — Diagnostics, calibration and repair",
        url: "/pages/services",
        words: "services electrical diagnostics repair sensor calibration coding parts warning light"
    },
    {
        title: "Appointments — Request service",
        url: "/pages/appointments",
        words: "appointments appointment book booking request service form make model year phone"
    },
    {
        title: "Contact — Instagram, address and home visits",
        url: "/pages/contact",
        words: "contact instagram address location directions canoga park home visit mobile"
    }
];

if (searchForm && results) {
    searchForm.addEventListener("submit", function (event) {
        event.preventDefault();

        const query = searchForm.elements.q.value.trim().toLowerCase();

        results.replaceChildren();

        if (!query) {
            return;
        }

        const matches = pages.filter(function (page) {
            return query.split(/\s+/).every(function (word) {
                return page.words.includes(word);
            });
        });

        if (matches.length === 0) {
            const message = document.createElement("p");

            message.textContent =
                "No matching pages. Try calibration, appointment or contact.";

            results.append(message);
        }

        matches.forEach(function (page) {
            const link = document.createElement("a");

            link.href = page.url;
            link.textContent = page.title;

            results.append(link);
        });
    });
}


// Close the other header menus when one opens.
const popups = document.querySelectorAll(".header-tools details");

popups.forEach(function (popup) {
    popup.addEventListener("toggle", function () {
        if (!popup.open) {
            return;
        }

        popups.forEach(function (other) {
            if (other !== popup) {
                other.open = false;
            }
        });
    });
});


// Press Escape to close an open header menu.
document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") {
        return;
    }

    popups.forEach(function (popup) {
        if (popup.open) {
            popup.open = false;
            popup.querySelector("summary").focus();
        }
    });
});


// Appointment form.
const serviceForm = document.querySelector("#service-form");

if (serviceForm) {
    const makeSelect = serviceForm.querySelector("#make");
    const otherBrandField = serviceForm.querySelector("#other-brand-field");
    const otherBrandInput = serviceForm.querySelector("#other-brand");
    const yearInput = serviceForm.querySelector("#year");
    const confirmation = document.querySelector("#confirmation");
    const submitButton = serviceForm.querySelector('button[type="submit"]');

    let sending = false;


    // Show a required typing field when Other is selected.
    function updateBrandField() {
        const isOther = makeSelect.value === "Other";

        otherBrandField.hidden = !isOther;
        otherBrandInput.disabled = !isOther;
        otherBrandInput.required = isOther;

        // Submit the typed brand instead of the word Other.
        makeSelect.name = isOther ? "" : "make";
        otherBrandInput.name = isOther ? "make" : "";
    }

    makeSelect.addEventListener("change", function () {
        updateBrandField();

        if (makeSelect.value === "Other") {
            otherBrandInput.focus();
        }
    });

    updateBrandField();

    yearInput.max = new Date().getFullYear() + 1;


    // Send the appointment request without opening another page.
    serviceForm.addEventListener("submit", async function (event) {
        event.preventDefault();

        if (sending || !serviceForm.reportValidity()) {
            return;
        }

        if (
            makeSelect.value === "Other" &&
            !otherBrandInput.value.trim()
        ) {
            confirmation.textContent = "Please enter your car brand.";
            otherBrandInput.focus();
            return;
        }

        const formData = new FormData(serviceForm);

        if (makeSelect.value === "Other") {
            formData.set("make", otherBrandInput.value.trim());
        }

        sending = true;
        submitButton.disabled = true;
        submitButton.textContent = "Sending...";
        confirmation.textContent = "Sending your request...";

        try {
            const response = await fetch(serviceForm.action, {
                method: "POST",
                body: formData,
                headers: {
                    Accept: "application/json"
                }
            });

            if (!response.ok) {
                confirmation.textContent =
                    "Your request could not be accepted. " +
                    "Please try again or contact us on Instagram.";

                return;
            }

            // Clear the form only after Formspree accepts the request.
            serviceForm.reset();
            updateBrandField();

            confirmation.textContent =
                "Thank you! Your request has been received. " +
                "Our specialist will contact you soon. " +
                "Your appointment is not confirmed yet.";

            confirmation.focus();
        } catch (error) {
            // Preserve the information when delivery is uncertain.
            confirmation.textContent =
                "We couldn't confirm whether your request arrived. " +
                "Please check your connection or contact us on Instagram.";
        } finally {
            sending = false;
            submitButton.disabled = false;
            submitButton.textContent = "Submit Request";
        }
    });
}